import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    a {\n        text-decoration: none;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        box-sizing: border-box;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Text } from '../Typography';
export var StyledText = styled(Text)(_templateObject(), function (props) {
  return "\n        transition: ".concat(props.theme.components.link.transition, ";\n        transition-property: color, box-shadow;\n        will-change: color, box-shadow;\n        color: ").concat(props.theme.components.link.unselectedColor, " !important;\n        box-shadow: ").concat(props.border ? "0 1px 0 0 ".concat(props.theme.components.link.unselectedColor) : 'none', ";\n\n        &:hover {\n            color: ").concat(props.theme.components.link.color, ";\n            box-shadow: ").concat(props.border ? "0 1px 0 0 ".concat(props.theme.components.link.color) : 'none', ";\n        }\n    ");
});
export var StyledLink = styled.span(_templateObject2());